import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import Navbar from '../components/UserDashboard/Navbar';
import TrainingRoom from '../components/UserDashboard/TrainingRoom';
import AIWorkshop from '../components/UserDashboard/AIWorkshop';
import JobBoard from '../components/UserDashboard/JobBoard';
import JobDescription from '../components/UserDashboard/JobDescription';
import StudentProfilePage from '../components/UserDashboard/StudentProfilePage';

function Students() {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };

  return (
    <div className={`employer-section ${isNavbarOpen ? 'navbar-open' : 'navbar-closed'}`}>
      <Navbar isOpen={isNavbarOpen} toggleNavbar={toggleNavbar} setIsOpen={setIsNavbarOpen} />
      <div className="content">
        <Routes>
          <Route path="training-room" element={<TrainingRoom />} />
          <Route path="ai-workshop" element={<AIWorkshop />} />
          <Route path="internship-board" element={<JobBoard />} />
          <Route path="/internship/:id/description" element={<JobDescription />} />
          <Route path="profile-settings" element={<StudentProfilePage />} />
          <Route path="/*" element={<TrainingRoom />} />
        </Routes>
      </div>
    </div>
  );
}

export default Students;